module.exports = __webpack_public_path__ + "static/media/delete_account.3227621b.png";